<style lang="scss">
@media screen and (max-width: 320px) {
  .date-pk span.required {
    font-size: 11.2px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 740px) {
  .save-info {
    margin-right: 0 !important;
    padding: 7px !important;
    width: 100%;
  }
  .cancel-btn {
    padding: 7px 30px !important;
    font-weight: 600;
    background: #f6f6f6;
    border: 2px solid #0d2e48;
    color: #0d2e48;
    width: 100%;
    margin-top: 5px;
  }
  .mobile-input {
    margin-top: 20px;
  }
  .form-data {
    margin-top: 20px;
  }
  .padding-mobile {
    padding: 0 !important;
  }
  .mobile-header {
    margin-bottom: 0;
  }
}
.form-control-file {
  overflow: hidden;
}
.save-info {
  background: #b4daf3;
  font-weight: 600;
  padding: 7px 70px;
  color: #0d2e48;
  margin-right: 20px;
  border: 2px solid #b4daf3;
}

label {
  font-weight: 600;
}

.input-group {
  margin-bottom: 0px !important;
}

.row {
  margin-bottom: 20px;
}

.cancel-btn {
  padding: 7px 45px;
  font-weight: 600;
  background: #f6f6f6;
  border: 2px solid #0d2e48;
  color: #0d2e48;
}

span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}

.form-data {
  text-align: center;
}
.image-evidence {
  max-width: 90%;
}
p.note {
  font-weight: 700;
  color: #ff1a1a;
}
</style>

<template>
  <CContainer>
    <ValidationObserver ref="formAdditionalTimeSheet" v-slot="{ handleSubmit }">
      <CRow>
        <CCol :md="{ size: '8', offset: '2' }" class="padding-mobile">
          <CCard>
            <CCardHeader>
              <label class="mobile-header">{{
                $t("fields.additional_timeSheet.label_create")
              }}</label>
            </CCardHeader>
            <CCardBody>
              <CForm
                class="create_form"
                @submit.prevent="handleSubmit(registerOverTimeRequest)"
              >
                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("fields.additional_timeSheet.request_date") }}
                      <span class="require">*</span>
                    </label>
                    <DatePickerForm
                      id="error-mobile"
                      :propsDate="forms.work_date"
                      v-on:emitDate="workDateData"
                      :rules="{
                        required_date: true,
                        before_or_equal_today: true
                      }"
                      :name="'additional_timeSheet.request_date'"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>
                      {{ $t("fields.additional_timeSheet.admin") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="additional_timeSheet.admin"
                    >
                      <select class="form-control" v-model="forms.admin_id">
                        <option
                          v-for="(option, index) in dataCreateForm.admin"
                          :key="index"
                          :value="option.id"
                          >{{ option.name }}</option
                        >
                      </select>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                   <CCol md="6" class="form-field mobile-input">
                    <label>
                      Manager
                    </label>
                    <CInput
                      type="text"
                      :disabled="true"
                      placeholder="Khúc Anh Minh Lượng"
                    />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="6" class="form-field">
                    <label>{{
                      $t("fields.additional_timeSheet.check_in_real")
                    }}</label>
                    <div class="form-control bg-text">
                      {{ forms.start_time_real | formatHour }}
                    </div>
                  </CCol>
                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("fields.additional_timeSheet.check_in_request") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="additional_timeSheet.check_in_request"
                    >
                      <b-form-input
                        type="text"
                        v-model="forms.start_time_request"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol md="6" class="form-field">
                    <label>{{
                      $t("fields.additional_timeSheet.check_out_real")
                    }}</label>
                    <div class="form-control bg-text">
                      {{ forms.end_time_real | formatHour }}
                    </div>
                  </CCol>
                  <CCol md="6" class="form-field mobile-input">
                    <label>
                      {{ $t("fields.additional_timeSheet.check_out_request") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="additional_timeSheet.check_out_request"
                    >
                      <b-form-input
                        type="text"
                        v-model="forms.end_time_request"
                        v-mask="'##:##'"
                        placeholder="HH:mm"
                      />
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="6" class="form-field">
                    <label>{{
                      $t("fields.additional_timeSheet.evidence")
                    }}</label>
                    <span class="require"> *</span>
                    <ValidationProvider
                      rules="image|size:2000"
                      v-slot="{ errors }"
                      name="additional_timeSheet.evidence"
                    >
                      <input
                        type="file"
                        class="form-control-file"
                        v-on:change="onImageChange"
                        id="fileImage"
                      />
                      <span v-if="!isImage" class="error image required">
                        {{ errorFileMessage }}
                      </span>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                  <CCol md="6">
                    <br />
                    <img
                      v-if="image_evidence"
                      v-img
                      class="image-evidence"
                      :src="image_evidence"
                      width="100"
                      height="100"
                    />
                    <img
                      v-else
                      class="image-evidence"
                      src="@/assets/images/no-image-available.jpg"
                      width="100"
                      height="100"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12" class="form-field">
                    <label>
                      {{ $t("fields.additional_timeSheet.reason") }}
                      <span class="require">*</span>
                    </label>
                    <ValidationProvider
                      rules="required|max:512"
                      v-slot="{ errors }"
                      name="additional_timeSheet.reason"
                    >
                      <b-form-textarea
                        id="textarea"
                        v-model="forms.reason"
                        rows="5"
                        max-rows="6"
                      ></b-form-textarea>
                      <span class="required">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="12" class="form-data">
                    <CButton type="submit" class="save-info">
                      {{ $t("label.save_infomation") }}
                    </CButton>
                    <CButton
                      class="cancel-btn"
                      type="button"
                      @click="cancel()"
                      >{{ $t("commons.cancel") }}</CButton
                    >
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </ValidationObserver>
  </CContainer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import moment from "moment";
import DatePickerForm from "@/components/commons/DatePickerForm";

export default {
  name: "CreateAdditionalTimesheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerForm
  },
  computed: {
    ...mapGetters({
      dataCreateForm: "additional-timesheet/dataCommonAdditionalTimeSheet"
    }),
    workDate() {
      return this.forms.work_date;
    }
  },
  data() {
    return {
      errorFileMessage: "",
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG"
      ],
      isImage: true,
      image_evidence: "",
      forms: {
        work_date: "",
        admin_id: "",
        start_time_real: "",
        end_time_real: "",
        end_time_request: "17:30",
        start_time_request: "08:00",
        reason: null,
        img_evidence: ""
      }
    };
  },

  created() {
    this.getDataCreateForm();
    if (this.$route.params.work_date) {
      this.forms.work_date = this.$route.params.work_date;
      this.forms.start_time_request =
        this.$route.params.start_time_real !== ""
          ? this.$route.params.start_time_real
          : this.forms.start_time_request;
      this.forms.end_time_request =
        this.$route.params.end_time_real !== ""
          ? this.$route.params.end_time_real
          : this.forms.end_time_request;
    } else {
      this.forms.work_date = moment(new Date()).format("DD/MM/YYYY");
    }
  },

  watch: {
    workDate() {
      this.getDataCreateForm();
    }
  },

  methods: {
    workDateData(data) {
      this.forms.work_date = data;
    },
    async registerOverTimeRequest() {
      if (this.forms.img_evidence === "") {
        this.isImage = false;
        this.errorFileMessage =
          this.$t("additional_timeSheet.evidence") +
          " " +
          this.$t("error.require");
        return false;
      }
      this.$root.$loading.start();
      let formData = new FormData();
      for (let key in this.forms) {
        if (key === "img_evidence") {
          if (
            this.forms.img_evidence !== null &&
            this.forms.img_evidence !== ""
          ) {
            formData.append("img_evidence", this.forms[key]);
          }
        } else {
          formData.append(key, this.forms[key]);
        }
      }
      await this.$store
        .dispatch("additional-timesheet/registerAdditionalTimeSheet", formData)
        .then(() => {
          let message = this.$t("overtime.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$router.push({ path: "/additional-timesheet" });
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    // change image
    onImageChange(e) {
      let file = e.target.files[0];
      if (
        e.target.files[0] &&
        !this.imageType.includes(e.target.files[0].type)
      ) {
        this.isImage = false;
        this.forms.img_evidence = "";
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      // check size file
      if (e.target.files[0] && e.target.files[0].size > 2000000) {
        this.isImage = false;
        this.errorFileMessage = this.$t("error.img_max");
        return;
      }
      //display image is choosen
      this.image_evidence = file !== undefined ? URL.createObjectURL(file) : "";
      this.errorFileMessage = null;
      this.isImage = true;
      this.forms.img_evidence =
        e.target.files[0] !== undefined ? e.target.files[0] : "";
    },

    async getDataCreateForm() {
      let date = moment(this.forms.work_date, "DD/MM/YYYY", true);
      if (date.isValid()) {
        this.$root.$loading.start();
        await this.$store.dispatch(
          "additional-timesheet/commonAdditionalTimeSheet",
          { work_date: this.forms.work_date }
        );
        let start_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.start_time_real
            : "";
        let end_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.end_time_real
            : "";
        this.forms.start_time_real =
          start_time_real !== null ? start_time_real : "";
        this.forms.end_time_real = end_time_real !== null ? end_time_real : "";
        this.forms.start_time_request =
          this.forms.start_time_real <= this.forms.start_time_request &&
          this.forms.start_time_real != ""
            ? this.forms.start_time_real
            : this.forms.start_time_request;
        this.forms.end_time_request =
          this.forms.end_time_real >= this.forms.end_time_request &&
          this.forms.end_time_real != ""
            ? this.forms.end_time_real
            : this.forms.end_time_request;
        let keyRandom = Math.floor(
          Math.random() * this.dataCreateForm.admin.length
        );
        this.forms.admin_id = this.dataCreateForm.admin[keyRandom].id;
        this.$root.$loading.finish();
      }
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.commons.label_popup_title"),
        this.$t("popup.commons.label_cancel_create"),
        this.$t("popup.commons.label_confirm_button"),
        this.$t("popup.commons.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$router.push({ path: "/additional-timesheet" });
        }
      });
    }
  }
};
</script>
